import http from 'plugins/axios';

export default {
    getCurrencyList({code, page, size, areaType}) {
        return http.post({
            url: '/admin/coin/list',
            data: {
                code,
                page,
                size,
                areaType
            },
            dataType: 'form'
        });
    },
    updateDepositStatus({coinType, status}) {
        return http.post({
            url: `/admin/coin/update/${coinType}/deposit/${status}`
        });
    },
    updateWithdrawStatus({coinType, status}) {
        return http.post({
            url: `/admin/coin/update/${coinType}/withdraw/${status}`
        });
    },
    createCurrency(data) {
        return http.post({
            url: '/admin/coin/create',
            data
        });
    },
    updateCurrency(data) {
        return http.post({
            url: '/admin/coin/update',
            data
        });
    },
    removeCurrency(code) {
        return http.post({
            url: '/admin/coin/remove',
            data: {
                code
            },
            dataType: 'form'
        });
    },
    updateTradeStatus({coinType, status}) {
        return http.post({
            url: `/admin/coin/update/${coinType}/trade/${status}`
        });
    },
    updateAggregateTradeStatus({coinType, status}) {
        return http.post({
            url: `/admin/coin/update/${coinType}/polymerTrade/${status}`
        });
    },
    updateDisplayStatus({coinType, status}) {
        return http.post({
            url: `/admin/coin/update/${coinType}/display/${status}`
        });
    },
    updateAreaType({coinType, type}) {
        return http.post({
            url: `/admin/coin/update/${coinType}/areaType/${type}`
        });
    },
    updateShelve({coinType, status}) {
        return http.post({
            url: `/admin/coin/update/${coinType}/shelve/${status}`
        });
    },
    updateSort({coinType, orderNo}) {
        return http.post({
            url: `/admin/coin/update/${coinType}/sort`,
            data: {
                coinType,
                orderNo
            },
            dataType: 'form'
        });
    },
    detail(coinType) {
        return http.get({
            url: `/admin/coin/detail/${coinType}`
        });
    },
    getCoinLogoInfo() {
        return http.get({
            url: '/admin/coin/logo'
        });
    },
    updateCoinLogoInfo(coinLogoInfoList) {
        return http.post({
            url: '/admin/coin/logo/update',
            data: {
                coinLogoInfoList
            }
        });
    },

    updateCoinDepositStatus(data) {
        return http.post({
            url: '/admin/coin/update/transfer',
            data,
            dataType: 'form'
        })
    },

    dragSort(data) {
        return http.post({
            url: '/admin/coin/update/sort',
            data,
            dataType: 'form'
        })
    },
    updateCoinBatch(data) {
        return http.post({
            url: '/admin/coin/update/batch',
            data,
            dataType: 'form'
        })
    },
    updateChainCoinBatch(data) {
        return http.post({
            url: '/admin/coin/update/chain',
            data,
            dataType: 'form'
        })
    },
    getContractCodeList(data) {
        return http.get({
            url: '/admin/coin/getEmptyConfAll',
            data
        })
    },
    getCoinConfig(data) {
        return http.get({
            url: '/admin/coinWithdrawFeeConfig/getCoinWithdrawFeeConfigByCoinConfigId',
            data
        })
    }
};
